const initialUserExerciseID = "";
//import { writable } from 'svelte/store'
//export const userExerciseIDStore = writable(initialUserExerciseID)
import { localStorageStringStore } from './localStorageStore';
export const userExerciseIDStore = localStorageStringStore('userExerciseIDStore', initialUserExerciseID);
